import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'design-react-kit';
// Funzione standalone esportabile (puoi usarla senza il componente)
export const copyToClipboard = async (text) => {
  try {
    if (!navigator.clipboard) {
      throw new Error('Clipboard API not supported');
    }
    const htmlBlob = new Blob([text], { type: 'text/html' });
    const textBlob = new Blob([text.replace(/<[^>]*>/g, '')], { type: 'text/plain' });

    const clipboardItem = new ClipboardItem({
      'text/html': htmlBlob,
      'text/plain': textBlob
    });

    await navigator.clipboard.write([clipboardItem]);
    return { success: true };
  } catch (err) {
    console.error('Copy failed:', err);
    return { success: false, error: err.message };
  }
};

// Componente che usa la funzione interna
const ClipboardButton = ({ text, children, style, className, toastify = null }) => {
  const [status, setStatus] = useState('idle');

  const handleCopy = async () => {
    setStatus('copying');
    try {
      const result = await copyToClipboard(text);
      if (toastify) {
        if (result.success) {
          toastify.toast.success("Link copiato con successo!", { autoClose: 2000 });
        } else {
          toastify.toast.error(`Errore durante la copia: ${result.error}`, { autoClose: 2000 });
        }
      }
      setStatus(result.success ? 'success' : 'error');
      setTimeout(() => setStatus('idle'), 2000);
    } catch (error) {
      if (toastify) {
        toastify.toast.error(`Errore sconosciuto durante la copia: ${error}`, { autoClose: 2000 });
      }
    }
  };

  const statusMessages = {
    idle: children || 'Copia negli appunti',
    copying: 'Copiando...',
    success: 'Copiato!',
    error: 'Errore'
  };

  return (
    <button
      onClick={handleCopy}
      disabled={status === 'copying'}
      style={style}
      className={className}
      aria-live="polite"
    >
      <Icon icon="it-copy" color="primary" title="Copia negli appunti." />
      {statusMessages[status]}
    </button>
  );
};

ClipboardButton.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  toastify: PropTypes.object,
};

export default ClipboardButton;